import React from 'react'
import PropTypes from 'prop-types'

import { useGetQuery } from '../../lib/api/get'
import { useCreateCall } from '../../lib/api/create'
import { ExamForm } from './ExamForm'

export const Exams = ({ setOpenFormModal, formSchema, isLocalEnvironment }) => {
  const createCallMutation = useCreateCall()
  const getData = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'syllabusCombination',
    params: '',
    isDynamic: true,
  })
  const [addExamModal, setAddExamModal] = React.useState(false)
  const [addExamModalData, setAddExamModalData] = React.useState(false)
  const [expandExam, setExpandExam] = React.useState(null)
  const [expandSubsExam, setExpandSubsExam] = React.useState(null)
  const [createExamsLoading, setCreateExamsLoading] = React.useState(false)

  const examAdd = (data) => {
    setAddExamModalData(data)
    setAddExamModal(true)
  }

  const examAddClose = () => {
    setAddExamModalData(null)
    setAddExamModal(false)
  }

  const onSubmit = async (data, selectedExam, addExamModalData) => {
    const formData = JSON.parse(selectedExam)
    formData.maxMarks = data.maxMarks
    formData.syllabusCombinationSubjectId = addExamModalData.syllabusCombinationSubjectId
    delete formData.createdDateTime
    delete formData.displayOrder
    delete formData.createdDateTime
    delete formData.examGroupId
    delete formData.examName
    delete formData.examShortName
    delete formData.lastUpdatedDateTime
    delete formData.subjectExams

    await createCallMutation.mutateAsync({
      url: isLocalEnvironment + '/addData',
      apiEndpoint: 'syllabusCombinationSubjectExam',
      parentAPI: 'syllabusCombination',
      data: formData,
      messageTitle: 'Exams',
      message: 'Exam added successfully!',
      params: '',
      isDynamic: true,
    })
  }

  const onCreateExams = async () => {
    setCreateExamsLoading(true)
    await createCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/addData',
        apiEndpoint: 'syllabusCombinationSubjectExam/generate',
        parentAPI: 'syllabusCombination',
        data: {},
        messageTitle: 'Exams',
        message: 'Exam created successfully!',
        params: '',
        isDynamic: true,
      })
      .then(() => setCreateExamsLoading(false))
      .catch(() => setCreateExamsLoading(false))
  }

  if (getData.isLoading) {
    return (
      <div
        className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
        aria-labelledby="exampleModalLabel"
        style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
        aria-modal="true"
        role="dialog"
      >
        <div className="trtui-modal-dialog trtui-modal-xl">
          <div className="trtui-modal-content">
            <div className="trtui-modal-header trtui-bg-light trtui-p-3">
              <h5 className="trtui-modal-title" id="exampleModalLabel">
                {formSchema.formTitle}
              </h5>
              <button
                type="button"
                className="trtui-btn-close"
                onClick={() => {
                  setOpenFormModal(false)
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ri-close-line" />
              </button>
            </div>
            <div className="trtui-modal-body">
              <div>
                <div
                  id="status"
                  className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
                  style={{
                    width: '40px',
                    height: '40px',
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    margin: '-20px 0 0 6.4rem',
                  }}
                >
                  <div
                    className="trtui-spinner-border trtui-text-primary trtui-avatar-sm"
                    role="status"
                  >
                    <span className="trtui-visually-hidden">Loading...</span>
                  </div>
                </div>
                <div
                  id="status"
                  className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
                  style={{
                    width: '40px',
                    height: '40px',
                    position: 'absolute',
                    left: '20%',
                    top: '50%',
                    margin: '-20px 0 0 6.4rem',
                  }}
                >
                  <div
                    className="trtui-spinner-border trtui-text-primary trtui-avatar-sm"
                    role="status"
                  >
                    <span className="trtui-visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              Exams
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => {
                setOpenFormModal(false)
              }}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-accordion trtui-custom-accordionwithicon trtui-accordion-secondary">
              <button
                type="button"
                onClick={() => onCreateExams()}
                disabled={createExamsLoading ? true : false}
                className="trtui-btn trtui-btn-primary trtui-btn-sm trtui-mb-3"
              >
                {createExamsLoading ? (
                  <span className="trtui-d-flex trtui-align-items-center">
                    <span className="trtui-flex-grow-1 trtui-me-2">Creating...</span>
                    <span className="trtui-spinner-border trtui-flex-shrink-0" role="status">
                      <span className="trtui-visually-hidden">Creating...</span>
                    </span>
                  </span>
                ) : (
                  'Creat Exams'
                )}
              </button>
              {!createExamsLoading &&
                getData.data?.formData?.length &&
                getData.data?.formData?.length > 0 &&
                getData.data?.formData?.map((syl, sylInd) => (
                  <div key={sylInd} className="trtui-accordion-item">
                    <h2
                      className="trtui-accordion-header"
                      onClick={() => setExpandExam(expandExam === sylInd ? null : sylInd)}
                    >
                      <button
                        className="trtui-accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accor_iconExamplecollapse1"
                        aria-expanded="true"
                        aria-controls="accor_iconExamplecollapse1"
                      >
                        {syl.syllabusCombinationName}
                      </button>
                    </h2>
                    <div
                      id="accor_iconExamplecollapse1"
                      className={`trtui-accordion-collapse trtui-collapse ${sylInd === expandExam ? 'trtui-show' : ''}`}
                      aria-labelledby="accordionwithiconExample1"
                      data-bs-parent="#accordionWithicon"
                    >
                      <div className="trtui-accordion-body">
                        {syl.combinationSubjects?.map((subs, subdInd) => (
                          <div
                            key={subdInd}
                            className="trtui-accordion trtui-custom-accordionwithicon-plus"
                          >
                            <div className="trtui-accordion-item">
                              <h2
                                className="trtui-accordion-header"
                                onClick={() =>
                                  setExpandSubsExam(expandSubsExam === subdInd ? null : subdInd)
                                }
                              >
                                <button className="trtui-accordion-button" type="button">
                                  {subs.subjects.subjectName}
                                </button>
                              </h2>
                              <div
                                className={`trtui-accordion-collapse trtui-collapse ${subdInd === expandSubsExam ? 'trtui-show' : ''}`}
                              >
                                <div className="trtui-accordion-body">
                                  <button
                                    type="button"
                                    className="trtui-btn trtui-btn-primary trtui-btn-sm trtui-mb-3"
                                    onClick={() => {
                                      addExamModal ? examAddClose() : examAdd(subs)
                                    }}
                                  >
                                    {addExamModal ? 'Close Add' : 'Add Exam'}
                                  </button>
                                  {addExamModal && (
                                    <ExamForm
                                      addExamModalData={addExamModalData}
                                      onSubmit={onSubmit}
                                    />
                                  )}
                                  {subs.syllabusCombinationSubjectExams
                                    .sort(
                                      (a, b) =>
                                        a.exam.examGroup.displayOrder -
                                          b.exam.examGroup.displayOrder ||
                                        a.exam.displayOrder - b.exam.displayOrder,
                                    )
                                    .map((exm, exmInd) => (
                                      <div key={exmInd}>
                                        {exm.exam.examGroup.examGroupName} - {exm.exam.examName}
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Exams.propTypes = {
  setOpenFormModal: PropTypes.func,
  formSchema: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
}
